import { useMemo } from 'react'
import queryString from 'query-string'
import { RecallQueryParams } from '@customTypes/Recall'
import { AppMode } from '@customTypes/Generic'
import { GapFillerQueryParams } from '@customTypes/GapFiller'

export const useRecallQueryParams = (): UseQueryParams<RecallQueryParams, undefined> => {
  return useMemo(() => {
    const params: RecallQueryParams = queryString.parse(window.location.search)

    if (params.mode !== AppMode.RECALL) {
      return { hasAllRequiredParams: false, queryParams: undefined, state: undefined }
    }

    return { hasAllRequiredParams: Boolean(params?.customerId), queryParams: params, state: undefined }
  }, [])
}

const isGapFillerDateValid = (appointmentDate: Date) => {
  return appointmentDate > new Date()
}

type UseQueryParams<QueryParams, State> = {
  hasAllRequiredParams: boolean
  queryParams: QueryParams | undefined
  state: State
}

type GapFillerState = {
  isStartDateValid: boolean
  hasStartInUrl: boolean
}

export const useGapFillerQueryParams = (): UseQueryParams<GapFillerQueryParams, GapFillerState> => {
  return useMemo(() => {
    const params: GapFillerQueryParams = queryString.parse(window.location.search)

    if (params.mode !== AppMode.GAP_FILLER) {
      return { hasAllRequiredParams: false, queryParams: undefined, state: {} as GapFillerState }
    }

    const hasStartInUrl = Boolean(params.start)
    const isStartDateValid = isGapFillerDateValid(new Date((params.start as string) ?? ''))

    if (params.practitionerReferenceIds) {
      params.practitionerReferenceIds = (params.practitionerReferenceIds as unknown as string).split(',')
    }

    return {
      hasAllRequiredParams: Boolean(params?.appointmentBundleReferenceId),
      queryParams: params,
      state: { isStartDateValid, hasStartInUrl },
    }
  }, [])
}
